import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth, API } from '../App';
import { t } from '../i18n';

export default function AdminAuditPage() {
  const { lang } = useAuth();
  const [rows, setRows] = useState([]);
  useEffect(() => { axios.get(`${API}/audit/admin`).then(r => setRows(r.data)); }, []);

  return (
    <div className="fade-up" data-testid="admin-audit-page">
      <div className="data-label accent-line text-[#DDA079] mb-3">{t(lang, 'nav.admin_audit')}</div>
      <h1 className="font-headings text-4xl text-white mb-2">Full Audit Log</h1>
      <p className="text-slate-400 mb-6">Every privileged action: settings change, FAQ decision, document upload, document deletion. Immutable.</p>

      {rows.length === 0 ? (
        <div className="text-slate-500 text-[13px]">{t(lang, 'common.empty')}</div>
      ) : (
        <div className="v-card overflow-hidden">
          <table className="w-full text-[12px]">
            <thead>
              <tr className="border-b border-white/10">
                <th className="data-label px-4 py-3 text-left">When</th>
                <th className="data-label px-4 py-3 text-left">Actor</th>
                <th className="data-label px-4 py-3 text-left">Action</th>
                <th className="data-label px-4 py-3 text-left">Target</th>
                <th className="data-label px-4 py-3 text-left">Details</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={r.id} data-testid={`admin-audit-row-${i}`} className="border-b border-white/5 hover:bg-white/[0.02]">
                  <td className="px-4 py-3 font-mono text-slate-400 whitespace-nowrap">
                    {new Date(r.ts).toLocaleString('en-IN', { dateStyle: 'short', timeStyle: 'short' })}
                  </td>
                  <td className="px-4 py-3 text-slate-300">{r.actor}</td>
                  <td className="px-4 py-3"><span className="v-badge cost">{r.action}</span></td>
                  <td className="px-4 py-3 text-white max-w-xs truncate">{r.target}</td>
                  <td className="px-4 py-3 font-mono text-[10px] text-slate-500 max-w-md truncate">{JSON.stringify(r.details)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
